export default __webpack_public_path__ + "static/media/svg-5.766f2b83.svg";